export const convertLocaleStringToNumber = (localeString: string): number => {
  return Number(localeString?.replaceAll(/\D/g, ""));
};

export const convertStringInputValueToNumber = (value: string): number => {
  try {
    return Number(value.replaceAll(",", "."));
  } catch (e) {
    console.log(`Unable to convert ${value} to number`);
    throw e;
  }
};
